import { BlockComment, BlockStatusCode } from '@bechtel/types';

export interface CommentHistoryProps {
  blockComments: BlockComment[];
  blockStatus: BlockStatusCode;
  canEditBlock: boolean;
}

export interface BlockCommentProps {
  blockStatus?: BlockStatusCode;
  canEditBlock: boolean;
}
